export default "__VITE_ASSET__C8YTdkRA__"